export const data: any = {
  NEXT_PUBLIC_BASE_URL: "https://positioningservices.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://positioningservices.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "positioningservices",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "9k5dj5b59lqq",
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_ONETRUST_ID: "48509740-8f33-4537-acb2-17d91cc509a7",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "positioningservices-production",
  NEXT_PUBLIC_VWO_ACCOUNT_ID: "1212944",
}
